export const DEFAULT_CURRENT_TEXT = "Present"

export const DEFAULT_AVAILABLE_CUSTOM_TAGS = 10

export const DEFAULT_AVAILABLE_TEMPLATES = 5

export const DEFAULT_AVAILABLE_USERS = 10

export let COPY_AVAILABLE = false
navigator.permissions
	// @ts-ignore: navigator permissions not yet in typescript
	?.query({ name: "clipboard-write" })
	.then((result) => {
		if (result.state === "granted") {
			COPY_AVAILABLE = true
		}
	})
	.catch(() => {
		console.log("Get clipboard write permission failed")
	})

export const SUPPORTED_LANGUAGES = [
	"Arabic",
	"English (British)",
	"English (American)",
	"Chinese (Simplified)",
	"Chinese (Traditional)",
	"Czech",
	"Danish",
	"Dutch",
	"Estonian",
	"Finnish",
	"French",
	"Gaelic",
	"German",
	"German (Swiss Standard)",
	"Hungarian",
	"Italian",
	"Japanese",
	"Korean",
	"Lithuanian",
	"Malay",
	"Mongolian (Cyrillic)",
	"Norwegian (Nynorsk)",
	"Norwegian (Bokmål)",
	"Polish",
	"Portuguese (Brazilian)",
	"Portuguese (European)",
	"Russian",
	"Slovak",
	"Spanish",
	"Swedish",
	"Thai",
]

export const DEFAULT_PROPS_FOR_LANGUAGE = {
	Arabic: { style: { direction: "rtl", textAlign: "right" } },
}

export const ALLOWED_IMAGE_TYPE_STRING = "image/jpeg, image/png, image/gif"
